import { memo } from "react";
import { Box, Card, Divider, Flex, H5, StatusDot } from "orcs-design-system";
import { isEmpty, map } from "lodash";
import ActionMenu from "../actionMenu";
import type { Insight } from "../../types";
import InsightDataRowItem from "./InsightDataRowItem";

type InsightPanelProps = {
  insight?: Insight;
  handleClickToTheTop: (type: string) => void;
};

const InsightPanel = ({ insight, handleClickToTheTop }: InsightPanelProps) => {
  if (isEmpty(insight)) {
    return null;
  }
  return (
    <Card>
      <Flex flexDirection="column">
        <Flex
          mb="r"
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
        >
          <Flex flexDirection="row" alignItems="center">
            <StatusDot variant="warning" mr="s" />
            <H5 fontWeight={600}>{insight.displayName}</H5>
          </Flex>
          <ActionMenu
            handleClickToTheTop={() => {
              handleClickToTheTop(insight.type);
            }}
          />
        </Flex>
        <Box my="r">
          <Divider light />
        </Box>
        <Flex my="r">
          <small>{insight?.description}</small>
        </Flex>
        <Flex flexDirection="column">
          {map(insight.data, (data, index) => (
            <InsightDataRowItem
              key={index}
              data={data}
              isFirst={index === 0}
              measureType={insight?.measureType}
            />
          ))}
        </Flex>
      </Flex>
    </Card>
  );
};

export default memo(InsightPanel);
